<template>
  <div class="calendar-page" id="app">
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <navtool :fromTo="1"></navtool>
    <div class="top-blank-div" :style="{height: (isDownloadShow?5:10)+(isApp?0:5)+'rem'}"></div>
    <!-- 吉日头部定位栏 -->
    <div class="calendar-head-line">
      <navbar :isApp="isApp"></navbar>

      <div v-if="!isDownloadShow" class="download-line">
        <!-- <img
          class="download-close-img"
          src="../../../assets/close.png"
          @click="closeDownloadLine()"
        /> -->
        <img class="download-app-img" src="../../../assets/downicon.png" />
        <div class="download-text">2024订婚/结婚吉日免费查询</div>
        <div class="download-btn" @click="gotoDownload()">APP查询</div>
      </div>
      <div id="downloadpop" class="downloadpop" v-if="showdownloadpop">
        <div class="popbox" v-show="!showMask">
            <p class="poptext">亲爱的会员：下载APP，预约可享受更多专属福利，还可享受平台补贴！</p>
            <div class="pop_btn">
              <div class="popleftbtn" @click="closeDownload">取消</div>
              <i></i>
              <span class="poprightbtn" @click="gotoDownload">打开婚芭莎APP</span>
            </div>
        </div>
        <div class="mask-open deep-mask" id="openAppMask" v-show="showMask" @click="closeDownload">
            </div>
        <div class="message-box deep-mask" v-show="showMask" @click="closeDownload">
            <b class="samp"></b>
            请点击右上角，在浏览器中打开，即可免费下载APP
        </div>
      </div>

      <!-- 吉日头部标题栏 -->
      <div class="calendar-title-line">
        <div class="calendar-date-pick">{{yearChose}}年{{monthChose}}月</div>
        <div class="calendar-date-pick-area" @click="showDatePicker()">
          <img src="../../../assets/downGrey.png" class="calendar-date-pick-img" />
        </div>
        <!-- <div class="calendar-auspicious-list" @click="gotoJiriList()">
          <span>筛选吉日</span>
          <img src="../../../assets/downGrey.png" class="calendar-date-pick-img-rigth">
        </div>-->

        <div class="condition-text-select" @click="selectJiriType()">
          {{jiriTypeName}}
          <img
            src="../../../assets/downGrey.png"
            class="calendar-date-pick-img-rigth"
          />
        </div>
        <div
          v-if="conditionShow"
          class="pop-background"
          @click="closeConditionArea()"
          @mousedown="closeConditionArea()"
        ></div>
        <div v-if="conditionShow" class="rectangle"></div>
        <div v-if="conditionShow" class="condition-area">
          <div
            class="bottom-border"
            :class="jiriType == 0 ? 'condition-tab-selected' : 'condition-tab'"
            @click="conditionClick(0)"
          >嫁娶吉日</div>
          <div
            class="bottom-border"
            :class="jiriType == 1 ? 'condition-tab-selected' : 'condition-tab'"
            @click="conditionClick(1)"
          >订婚吉日</div>
          <div
            class="bottom-border"
            :class="jiriType == 5 ? 'condition-tab-selected' : 'condition-tab'"
            @click="conditionClick(5)"
          >领证吉日</div>
          <div
            class="bottom-border"
            :class="jiriType == 2 ? 'condition-tab-selected' : 'condition-tab'"
            @click="conditionClick(2)"
          >彩礼吉日</div>
          <div
            class="bottom-border"
            :class="jiriType == 3 ? 'condition-tab-selected' : 'condition-tab'"
            @click="conditionClick(3)"
          >纳婿吉日</div>
          <div
            :class="jiriType == 4 ? 'condition-tab-selected' : 'condition-tab'"
            @click="conditionClick(4)"
          >全部吉日</div>
        </div>
      </div>
    </div>

    <div class="calendar-area">
      <!-- 日历星期标题 -->
      <div class="calendar-week-title-line">
        <div class="calendar-week-title">一</div>
        <div class="calendar-week-title">二</div>
        <div class="calendar-week-title">三</div>
        <div class="calendar-week-title">四</div>
        <div class="calendar-week-title">五</div>
        <div class="calendar-week-title-weekend">六</div>
        <div class="calendar-week-title-weekend">日</div>
      </div>

      <!-- 日历月份显示部分 -->
      <v-touch
        v-on:swipeleft="onSwipeLeft()"
        v-on:swiperight="onSwipeRight()"
        v-on:swipeup="onSwipeUp()"
        v-on:swipedown="onSwipeDown()"
      >
        <div class="calendar-month-date-area">
          <div
            v-if="isCalendarShow"
            v-for="(dateItem, index) in dateList"
            v-bind:key="dateItem.ymd"
            @click="dateTap(dateItem.ymd,dateItem.isNow)"
          >
            <div
              v-if="dateItem.isNow && !isHoliday(index)"
              :class=" choseDate == dateItem.ymd ? 'date-info-cell-selected' : 'date-info-cell'"
            >
              <div
                v-if="(!dateItem.collectionId || dateItem.collectionId == 0) && dateItem.isJiri"
                class="ji-icon"
              ></div>
              <div
                v-if="dateItem.collectionId && dateItem.collectionId != 0"
                class="collection-icon"
              ></div>

              <div class="bold-font">{{dateItem.ymd.substr(6) * 1}}</div>
              <div
                v-if="dateItem.redFlg == 0"
                :class=" choseDate == dateItem.ymd ? 'p-style-selected' : 'p-style'"
              >{{dateItem.finalDateDescribe}}</div>
              <div
                v-if="dateItem.redFlg == 1"
                :class=" choseDate == dateItem.ymd ? 'p-style-selected' : 'p-style-holiday'"
              >{{dateItem.finalDateDescribe}}</div>
            </div>
            <div
              v-if="dateItem.isNow && isHoliday(index)"
              :class=" choseDate == dateItem.ymd ? 'date-info-cell-selected' : 'date-info-holiday-cell'"
            >
              <div
                v-if="(!dateItem.collectionId || dateItem.collectionId == 0) && dateItem.isJiri"
                class="ji-icon"
              ></div>
              <div
                v-if="dateItem.collectionId && dateItem.collectionId != 0"
                class="collection-icon"
              ></div>
              <div class="bold-font">{{dateItem.ymd.substr(6) * 1}}</div>
              <div
                v-if="dateItem.redFlg == 0"
                :class=" choseDate == dateItem.ymd ? 'p-style-selected' : 'p-style'"
              >{{dateItem.finalDateDescribe}}</div>
              <div
                v-if="dateItem.redFlg == 1"
                :class=" choseDate == dateItem.ymd ? 'p-style-selected' : 'p-style-holiday'"
              >{{dateItem.finalDateDescribe}}</div>
            </div>

            <div v-if="!dateItem.isNow" class="date-info-cell-grey">
              <div class="bold-font">{{dateItem.ymd.substr(6) * 1}}</div>
              <div class="p-style-grey">{{dateItem.finalDateDescribe}}</div>
            </div>
          </div>
        </div>
      </v-touch>
    </div>

    <!-- 收藏信息弹出框 -->
    <div v-if="collectionPopShow" class="collection-message-pop">{{collectionMessage}}</div>
    <div v-if="overrunPopShow" class="overrun-message-pop">{{overrunMessage}}</div>
    <div v-if="appPopShow" class="app-message-pop">
      {{appMessage}}
      <br />
      {{appMessageDown}}
    </div>

    <!-- 选中日期信息浮窗 -->
    <div id="jiriInfoRef" class="calendar-date-info-area">
      <div class="date-info-line1">
        <div class="date-info-line1-left">
          <div class="date-info-date-text">{{chosenDateItem.date}}</div>
          <div class="date-info-detail-area">
            <div class="date-info-lanur-date">{{chosenDateItem.finalDateDescribe}}</div>
            <div
              class="date-info-week-detail"
            >{{chosenDateItem.yaerMonth}} {{chosenDateItem.weekStr}}</div>
          </div>
        </div>
        <div class="date-info-line1-right">
          <div class="date-info-yiji-right">
            <img
              v-if="chosenDateItem.yiji2 == 1"
              class="date-info-yiji-icon"
              src="../../../assets/yi.png"
            />
            <img
              v-if="chosenDateItem.yiji2 == 2"
              class="date-info-yiji-icon"
              src="../../../assets/ji.png"
            />
            <img
              v-if="chosenDateItem.yiji2 == 3"
              class="date-info-yiji-icon"
              src="../../../assets/ping.png"
            />
            <div class="date-info-yiji-text calendar-margin-right-2">订婚</div>
          </div>
          <div class="date-info-yiji-left">
            <img
              v-if="chosenDateItem.yiji1 == 1"
              class="date-info-yiji-icon margin-left-first"
              src="../../../assets/yi.png"
            />
            <img
              v-if="chosenDateItem.yiji1 == 2"
              class="date-info-yiji-icon margin-left-first"
              src="../../../assets/ji.png"
            />
            <img
              v-if="chosenDateItem.yiji1 == 3"
              class="date-info-yiji-icon margin-left-first"
              src="../../../assets/ping.png"
            />
            <div class="date-info-yiji-text calendar-margin-right-2">嫁娶</div>
          </div>
          <div class="date-info-yiji-right">
            <img
              v-if="chosenDateItem.yiji4 == 1"
              class="date-info-yiji-icon"
              src="../../../assets/yi.png"
            />
            <img
              v-if="chosenDateItem.yiji4 == 2"
              class="date-info-yiji-icon"
              src="../../../assets/ji.png"
            />
            <img
              v-if="chosenDateItem.yiji4 == 3"
              class="date-info-yiji-icon"
              src="../../../assets/ping.png"
            />
            <div class="date-info-yiji-text">纳婿</div>
          </div>
          <div class="date-info-yiji-left">
            <img
              v-if="chosenDateItem.yiji5 == 1"
              class="date-info-yiji-icon"
              src="../../../assets/yi.png"
            />
            <img
              v-if="chosenDateItem.yiji5 == 2"
              class="date-info-yiji-icon"
              src="../../../assets/ji.png"
            />
            <img
              v-if="chosenDateItem.yiji5 == 3"
              class="date-info-yiji-icon"
              src="../../../assets/ping.png"
            />
            <div class="date-info-yiji-text calendar-margin-right-2">领证</div>
          </div>
        </div>
      </div>

      <div v-if="!isApp" class="date-info-line2">
        <img
          v-if="chosenDateItem.isCollection == 0"
          class="date-info-function-icon"
          src="../../../assets/collectionRep.png"
          @click="doCollection()"
        />
        <img
          v-if="chosenDateItem.isCollection == 1"
          class="date-info-function-icon"
          src="../../../assets/collectionSelectedRep.png"
          @click="doCollection()"
        />
        <div class="date-info-function-text margin-right-4-5" @click="doCollection()">收藏吉日</div>
        <div class="sure-line-no-share"></div>
        <div
          class="date-info-collection-area"
          v-if="collectionCntType == 1"
          @click="gotoMyCollection()"
        >
          <img class="date-info-function-icon" src="../../../assets/collectionRep.png" />
          <div class="date-info-function-text">我的收藏</div>
          <img class="date-info-collection-right-icon" src="../../../assets/right.png" />
        </div>
        <div
          class="date-info-collection-area"
          v-if="collectionCntType == 2"
          @click="gotoMyCollection()"
        >
          <img class="date-info-function-icon" src="../../../assets/collectionSelectedRep.png" />
          <div class="date-info-function-text">我的收藏</div>
          <div class="date-info-collection-count">{{collectionCnt}}</div>
          <img class="date-info-collection-right-icon" src="../../../assets/right.png" />
        </div>
        <div
          class="date-info-collection-area"
          v-if="collectionCntType == 3"
          @click="gotoMyCollection()"
        >
          <img class="date-info-function-icon" src="../../../assets/collectionSelectedRep.png" />
          <div class="date-info-function-text">我的收藏</div>
          <div class="date-info-collection-count">{{collectionCnt}}</div>
          <img class="date-info-collection-right-icon" src="../../../assets/right.png" />
        </div>
      </div>

      <div v-if="isApp" class="date-info-line2-app">
        <img
          v-if="chosenDateItem.isCollection == 0"
          class="date-info-function-icon-app"
          src="../../../assets/collectionRep.png"
          @click="doCollection()"
        />
        <img
          v-if="chosenDateItem.isCollection == 1"
          class="date-info-function-icon-app"
          src="../../../assets/collectionSelectedRep.png"
          @click="doCollection()"
        />
        <div class="date-info-function-text-app" @click="doCollection()">收藏吉日</div>
        <div class="sure-line"></div>
        <img
          class="date-info-function-icon-app margin-left-4-5-app"
          src="../../../assets/shareRep.png"
          @click="doShare()"
        />
        <div class="date-info-function-text-app  share-width" @click="doShare()">分享给家人</div>
        <div class="sure-line"></div>
        <div
          class="date-info-collection-area-app"
          v-if="collectionCntType == 1"
          @click="gotoMyCollection()"
        >

          <img class="date-info-function-icon-app" src="../../../assets/collectionRep.png" />
          <div class="date-info-function-text-app">我的收藏</div>
          <img class="date-info-collection-right-icon-app" src="../../../assets/right.png" />
        </div>
        <div
          class="date-info-collection-area-app"
          v-if="collectionCntType == 2"
          @click="gotoMyCollection()"
        >
          <img class="date-info-function-icon-app" src="../../../assets/collectionSelectedRep.png" />
          <div class="date-info-function-text-app">我的收藏</div>
          <div class="date-info-collection-count-app">{{collectionCnt}}</div>
          <img class="date-info-collection-right-icon-app" src="../../../assets/right.png" />
        </div>
        <div
          class="date-info-collection-area-app"
          v-if="collectionCntType == 3"
          @click="gotoMyCollection()"
        >
          <img class="date-info-function-icon-app" src="../../../assets/collectionSelectedRep.png" />
          <div class="date-info-function-text-app">我的收藏</div>
          <div class="date-info-collection-count-app">{{collectionCnt}}</div>
          <img class="date-info-collection-right-icon-app" src="../../../assets/right.png" />
        </div>
      </div>
    </div>
    <div class="calendar-date-info-area2" v-if="!(cityId==0||!cityId)">
      <div class="date-info-line3">
        <div class="date-info-hotel" @click="doHotel()">
          <img class="date-info-hotel-btnImg" src="../../../assets/hotelSelect.png" />
          <div class="date-info-hotel-text">酒店查询</div>
        </div>
        <div class="date-info-hotel" @click="doHotel('hotel')">
          <img class="date-info-hotel-btnImg" src="../../../assets/hot.png" />
          <div class="date-info-hotel-text">极速抢档期</div>
          <div class="date-info-hotel-hot">HOT</div>
        </div>
      </div>
      <!-- 书链效果 -->
      <div class="book-chain-left">
        <img class="book-chain-icon" src="../../../assets/connectingLine.png" />
      </div>
      <div class="book-chain-right">
        <img class="book-chain-icon" src="../../../assets/connectingLine.png" />
      </div>
    </div>
    <!-- 日期选择器 -->
    <awesome-picker
      ref="picker"
      :anchor="anchor"
      :data="pickerData"
      colorCancel="#FF6363"
      colorConfirm="#FF6363"
      class="date-picker-column"
      @confirm="handlePickerConfirm"
    ></awesome-picker>
  </div>
</template>

<script>
import axios from 'axios'
import GLOBAL from '../../../components/jiri/Global'
import appCall from '../../../../plugins/appCall.js'
import browers from '../../../../plugins/browser.js'
import AppCalls from '../../preview/appcall/utils/appcall.js'
import { setTimeout } from 'timers'
import 'mint-ui/lib/style.css'
import Navbar from '../../../components/navbar/app.vue'
import Navtool from '../../../components/navtool/app.vue'
import callapp from 'callapp'

export default {
  components: {
    Navbar,
    Navtool
  },
  beforeMount() {},
  mounted() {
    var that = this
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    // 获取token和城市ID
    that.getTokenAndCity()
    // 获取酒店预订地址
    that.getHotelUrl()
    // 判断是否为app内
    that.isDownloadShow = browers().isApp
    that.isApp = browers().isApp
    // 设置标题
    document.title = '结婚吉日'
    var now = new Date()

    // 从我的收藏页面点击收藏的吉日跳转至结婚吉日日历，将年月设置为选中的吉日年月，并对选中的日期做选中效果处理
    if (GLOBAL.getUrlParam('collectionDate')) {
      that.choseDate = decodeURI(GLOBAL.getUrlParam('collectionDate'))
      // 将时间设置为选中的日期
      now.setFullYear(parseInt(that.choseDate.substr(0, 4)))
      now.setMonth(parseInt(that.choseDate.substr(4, 2)) - 1)
      now.setDate(parseInt(that.choseDate.substr(6, 2)))
      // 设置选中年份
      that.yearChose = parseInt(that.choseDate.substr(0, 4))
      // 设置选中月份
      that.monthChose = parseInt(that.choseDate.substr(4, 2))
    } else {
      // 设置选中日期为当前日期
      var tempChoseDate = ''
      tempChoseDate = now.getFullYear() + ''
      // 设置月份
      if (now.getMonth() + 1 < 10) {
        tempChoseDate += '0' + (now.getMonth() + 1)
      } else {
        tempChoseDate += '' + (now.getMonth() + 1)
      }
      // 设置日期
      if (now.getDate() < 10) {
        tempChoseDate += '0' + now.getDate()
      } else {
        tempChoseDate += '' + now.getDate()
      }
      // 设置选中日期
      that.choseDate = tempChoseDate
    }

    // 设置选中年月
    that.setChoseMonth(now)
    // 月份变更事件
    that.changeMonth(now)

    //数据上报
    window.$action = new postdata({
      appkey: 'hunbasha_wap',
      pageName: location.pathname,
      sensor_option: {
        openAll: true
      }
    })
  },
  data() {
    return {
      showMask: false,
      conditionShow: false, // 吉日类型下拉弹窗是否显示 true：显示 false：隐藏
      jiriType: 4, // 吉日类型 0：假期 1：订婚 2：彩礼 3：纳婿 5：领证
      jiriTypeName: '筛选吉日', // 吉日类型名称
      startDateStr: '',
      endDateStr: '',
      /*分割*/

      cityId: 0, // 城市ID
      token: '', // token
      collectionCntType: 1, // 收藏总数类型 1：未收藏 2: 收藏数为1~99 3：收藏数99+
      collectionPopShow: false, // 收藏信息提示框显示状态 ture：显示 false：隐藏
      overrunPopShow: false, //收藏超限错误提示框显示状态 ture：显示 false：隐藏
      collectionMessage: '', // 收藏信息提示框显示内容
      overrunMessage: '', // 收藏超限错误提示框显示内容
      collectionCnt: '', // 收藏总数
      anchor: [0, 0], // 日期选择器中当前选中年月的下标
      pickerData: [
        [
          '2018年',
          '2019年',
          '2020年',
          '2021年',
          '2022年',
          '2023年',
          '2024年',
          '2025年'
        ],
        [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ]
      ], // 日期选择器内容
      firstTime: true, // 是否第一次进入画面
      yearChose: 2018, // 当前选中年份
      monthChose: 1, // 当前选中月份
      dateList: [], // 整月日期列表
      isCalendarShow: true, // 日历内容是否显示 true：显示 false：隐藏
      years: [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025], // 年份列表
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], // 月份列表
      datePickerValue: [0, 1], // 当前选中年月下标
      // dateIndex: -1,
      choseDate: '', // 当前选中日期
      chosenDateItem: {
        date: '',
        finalDateDescribe: '',
        yaerMonth: '',
        weekStr: '',
        isCollection: 1,
        yiji1: 1,
        yiji2: 1,
        yiji3: 1,
        yiji4: 1,
        yiji5: 1
      }, // 当前选中日期信息
      hotelUrl: '', // 酒店预订地址
      isLoading: true,
      isDownloadShow: false, // true：不显示 false：显示
      appMessage: '', // 提示信息上一行
      appMessageDown: '', // 提示信息下一行
      appPopShow: false,
      isApp: false,
      showdownloadpop: false
    }
  },

  methods: {
    /**
     * 显示吉日类型切换弹窗
     */
    selectJiriType() {
      var that = this
      that.conditionShow = true
    },
    /**
     * 关闭吉日类型切换弹窗
     */
    closeConditionArea() {
      var that = this
      that.conditionShow = false
    },
    /**
     * 吉日类型切换
     */
    conditionClick(conditionType) {
      var that = this
      if (conditionType == 0) {
        ;(that.jiriTypeName = '嫁娶吉日'), (that.jiriType = 0)
      } else if (conditionType == 1) {
        ;(that.jiriTypeName = '订婚吉日'), (that.jiriType = 1)
      } else if (conditionType == 2) {
        ;(that.jiriTypeName = '彩礼吉日'), (that.jiriType = 2)
      } else if (conditionType == 3) {
        ;(that.jiriTypeName = '纳婿吉日'), (that.jiriType = 3)
      } else if (conditionType == 5) {
        ;(that.jiriTypeName = '领证吉日'), (that.jiriType = 5)
      } else {
        ;(that.jiriTypeName = '全部吉日'), (that.jiriType = 4)
      }
      // 后台API请求数据
      let requestData = {
        startDate: that.startDateStr,
        endDate: that.endDateStr,
        jiriType: conditionType
      }
      // 设置吉日类型
      that.jiriType = conditionType
      console.log('GLOBAL.getUrlDomain()', GLOBAL.getUrlDomain())
      // 获取所有吉日列表
      axios
        .post(GLOBAL.getUrlDomain() + 'getAllAuspiciousDayList', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        })
        .then(
          function(response) {
            var code = response.data.code
            // 成功
            if (code === 0) {
              var auspiciousDayList = response.data.data.auspiciousList
              // 如果吉日列表存在

              for (var i = 0; i < that.dateList.length; i++) {
                that.dateList[i].isJiri = false
                if (auspiciousDayList && auspiciousDayList.length > 0) {
                  for (var j = 0; j < auspiciousDayList.length; j++) {
                    if (
                      auspiciousDayList[j].auspiciousDate ==
                      that.dateList[i].ymd
                    ) {
                      if (
                        conditionType == 0 &&
                        auspiciousDayList[j].jiriType == 0
                      ) {
                        that.dateList[i].isJiri = true
                      } else if (
                        conditionType == 1 &&
                        auspiciousDayList[j].jiriType == 1
                      ) {
                        that.dateList[i].isJiri = true
                      } else if (
                        conditionType == 2 &&
                        auspiciousDayList[j].jiriType == 2
                      ) {
                        that.dateList[i].isJiri = true
                      } else if (
                        conditionType == 3 &&
                        auspiciousDayList[j].jiriType == 3
                      ) {
                        that.dateList[i].isJiri = true
                      } else if (
                        conditionType == 5 &&
                        auspiciousDayList[j].jiriType == 5
                      ) {
                        that.dateList[i].isJiri = true
                        // } else if (
                        //   conditionType == 4 &&
                        //   (that.dateList[i].jiriType == 1 ||
                        //     that.dateList[i].jiriType == 1 ||
                        //     that.dateList[i].jiriType == 2 ||
                        //     that.dateList[i].jiriType == 3 ||
                        //     that.dateList[i].jiriType == 5)
                        // ) {
                      } else if (
                        conditionType == 4 &&
                        auspiciousDayList[j].yijiType == 1
                      ) {
                        that.dateList[i].isJiri = true
                      }
                    }
                  }
                }
              }
            } else if (code === -1) {
              that.dateInfoShow = false
            }
          }.bind(this)
        )
        .catch(function() {
          // 这里是处理错误的回调
          that.dateInfoShow = false
        })

      // 关闭吉日类型切换弹窗
      that.conditionShow = false
      // 清除选中日期
      //that.choseDate = ''
      // 获取吉日类别列表
      //console.log('dateList',that.dateList)
    },

    /* 分割 */

    /**
     * 关闭下载行
     */
    closeDownloadLine() {
      var that = this
      that.isDownloadShow = true
    },
    closeDownload() {
      this.showMask = false
      this.showdownloadpop = false
    },
    /**
     * 下载
     */
    gotoDownload() {
      if (browers().isWeixinWeibo && browers().isApp) {
        this.showMask = true
        this.showdownloadpop = true
      } else {
        location.href = 'https://file.hbhcdn.com/open?k=h5url_' + location.href
      }
      // appCall.active({
      //   app_channel: 'JHJR_qgdbyd',
      //   url: 'ciw://tab/home',
      //   isdownload: true,
      //   gourl: ''
      // })
    },
    /**
     * 获取token和城市ID
     */
    getTokenAndCity() {
      var that = this
      // 城市ID
      that.cityId = GLOBAL.getCookie('city-id')
      // token
      that.token = GLOBAL.getCookie('Authorization')
    },
    /**
     * 跳转至吉日列表画面
     */
    // gotoJiriList() {
    //   location.assign('jiriList.html')
    // },

    /**
     * 判断是否在app内打开，如果不是提示'请在app内操作'
     */
    isDownloadMessageShow() {
      var that = this
      if (!browers().isApp) {
        // 设置未登录提示信息
        that.appMessage = '请在APP中操作哦'
        that.appMessageDown = '（点击上方下载APP）'
        // 显示未登录信息提示弹窗
        that.appPopShow = true
        // 1秒后自动关闭收藏信息提示弹窗
        setTimeout(that.closeAppPop, 1000)
        return true
      } else {
        return false
      }
    },

    /**
     * 关闭收藏信息提示弹窗
     */
    closeAppPop() {
      var that = this
      that.appMessage = ''
      that.appMessageDown = ''
      that.appPopShow = false
    },

    /**
     * 跳转至我的收藏画面
     */
    gotoMyCollection() {
      var that = this
      // 判断是否在app内打开，如果不是提示'请在app内操作'
      // if (that.isDownloadMessageShow()) {
      //   return
      // }
      if (!that.token) {
        // // 设置未登录提示信息
        // that.collectionMessage = '您还未登录，请先登录!'
        // // 显示未登录信息提示弹窗
        // that.collectionPopShow = true
        // // 1秒后自动关闭收藏信息提示弹窗
        // setTimeout(that.closeCollectionPop, 1000)
        // TODO 调用登录画面
        if (browers().isApp) {
          AppCalls.callapp('loginApp', {}, 'location.reload')
        } else {
          GLOBAL.h5Login(
            location.protocol +
              '//' +
              location.host +
              '/luckyday/myCollection?fromPage=0'
          )
        }
        return
      }
      location.assign('myCollection.html?fromPage=0') // 跳转源页面 0：首页 1：吉日列表
    },

    /**
     * 分享吉日
     */
    doShare() {
      var that = this
      // 判断是否在app内打开，如果不是提示'请在app内操作'
      if (that.isDownloadMessageShow()) {
        return
      }
      if (GLOBAL.DEV_MODE) {
        location.assign('share.html?choseDate=' + that.choseDate)
      } else {
        // 分享
        var shareUrl =
          location.origin +
          '/luckyday/index.html?pageName=Share&choseDate=' +
          that.choseDate

        var contentText =
          that.choseDate.substr(0, 4) +
          '年' +
          that.choseDate.substr(4, 2) +
          '月' +
          that.choseDate.substr(6, 2) +
          '日：'
        // 嫁娶
        if (that.chosenDateItem.yiji1 == 1) {
          contentText += '宜嫁娶；'
        } else if (that.chosenDateItem.yiji1 == 2) {
          contentText += '忌嫁娶；'
        } else if (that.chosenDateItem.yiji1 == 3) {
          contentText += '平嫁娶；'
        }
        // 订婚
        if (that.chosenDateItem.yiji2 == 1) {
          contentText += '宜订婚；'
        } else if (that.chosenDateItem.yiji2 == 2) {
          contentText += '忌订婚；'
        } else if (that.chosenDateItem.yiji2 == 3) {
          contentText += '平订婚；'
        }
        // 彩礼
        if (that.chosenDateItem.yiji3 == 1) {
          contentText += '宜彩礼；'
        } else if (that.chosenDateItem.yiji3 == 2) {
          contentText += '忌彩礼；'
        } else if (that.chosenDateItem.yiji3 == 3) {
          contentText += '平彩礼；'
        }
        // 纳婿
        if (that.chosenDateItem.yiji4 == 1) {
          contentText += '宜纳婿'
        } else if (that.chosenDateItem.yiji4 == 2) {
          contentText += '忌纳婿'
        } else if (that.chosenDateItem.yiji4 == 3) {
          contentText += '平纳婿'
        }
        // 领证
        if (that.chosenDateItem.yiji5 == 1) {
          contentText += '宜领证'
        } else if (that.chosenDateItem.yiji5 == 2) {
          contentText += '忌领证'
        } else if (that.chosenDateItem.yiji5 == 3) {
          contentText += '平领证'
        }
        var args = {
          title: '我挑到了一个结婚好日子，来帮我看看～',
          content: contentText,
          message: contentText,
          url: shareUrl,
          img_url:
            'https://img.hbhcdn.com/dmp/other/1537113600/jh-img-orig-ga_1041595644332277760_100_100_10075.png'
        }

        that.callapp('ui_share', args, '')
      }
    },

    /**
     * 调用app原生方法
     */
    callapp(handlerName, args, callbackName) {
      args = JSON.stringify(args) ? JSON.stringify(args) : ''

      // 获取UserAgent
      var u = navigator.userAgent
      // 安卓
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      // IOS
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

      // IOS
      if (isiOS) {
        window.webkit.messageHandlers.ios.postMessage({
          handler: handlerName,
          args: args,
          callback: callbackName
        })
      }
      // 安卓
      if (isAndroid) {
        window.hapj_hybrid.android(handlerName, args, callbackName)
      }
    },

    /**
     * 预订酒店
     */
    doHotel(type) {
      if (type === 'hotel') {
        // 判断是否在app内打开，如果不是提示'请在app内操作'
        if (!browers().isApp) {
          this.showMask = false
          this.showdownloadpop = true
          // location.replace(
          //   'https://www.jiehun.com.cn/mobile/download/?app_channel=JHJR_qgscjr'
          // )
          return false
        }
        let hotelUrl = this.isApp
          ? 'ciw://channel/research/item?industryId=1000'
          : this.hotelUrl
        this.postData('do_hotel', '', hotelUrl)
        return
      }

      // 判断是否在app内打开，如果不是提示'请在app内操作'
      if (this.isApp) {
        this.postData(
          'luckyday_seek_hotel',
          '',
          `ciw://mobile/get-home-channel?cate_id=1000`
        )
      } else {
        let cityName = ''
        switch (this.cityId) {
          case '110900':
            cityName = 'beijing'
            break
          case '120300':
            cityName = 'tianjin'
            break
          case '310900':
            cityName = 'shanghai'
            break
          case '330100':
            cityName = 'hangzhou'
            break
          case '420100':
            cityName = 'wuhan'
            break
          case '440100':
            cityName = 'guangzhou'
            break
          case '510100':
            cityName = 'chengdu'
            break
          default:
            cityName = 'quanguo'
            break
        }
        // 点击酒店查询，跳转app喜宴酒店页面或是h5的喜宴酒店页面
        // 跳转至酒店预订画面
        this.postData(
          'luckyday_seek_hotel',
          '',
          `${process.env.VUE_APP_M_HOST}/${cityName}/ch1000`
        )
      }
    },

    /**
     * 获取酒店预订地址
     */
    getHotelUrl() {
      var that = this
      var requestData = {}
      // 获取酒店预订地址
      axios
        .post(GLOBAL.getUrlDomain() + 'getHotelUrl', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'city-id': that.cityId,
            Authorization: that.token
          }
        })
        .then(
          function(response) {
            var code = response.data.code
            // 成功
            if (code === 0) {
              // 设置酒店预订地址
              that.hotelUrl = response.data.data
            } else if (code === -1) {
              console.log(response.data.message)
            }
          }.bind(this)
        )
        .catch(function(response) {
          // 这里是处理错误的回调
          console.log(response)
        })
    },

    /**
     * 设置当前所选月份
     */
    setChoseMonth(now) {
      var that = this
      // var tempDatePickerValue = []
      // 设置当前所选年份下标
      for (var i = 0; i < that.years.length; i++) {
        if (now.getFullYear() == that.years[i]) {
          that.anchor[0] = i
          break
        }
      }
      // 设置当前所选月份下标
      for (var l = 0; l < that.months.length; l++) {
        if (now.getMonth() + 1 == that.months[l]) {
          that.anchor[1] = l
          break
        }
      }
    },

    /**
     * 根据年份和月份计算所选月份的天数
     */
    countDays(year, month) {
      // 定义月份的数组
      var days_in_months = new Array(
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      )
      // 函数运行可以直接返回一个数值
      if (1 == month) {
        return (0 == year % 4 && 0 != year % 100) || 0 == year % 400 ? 29 : 28
      } else {
        return days_in_months[month]
      }
    },

    /**
     * 月份变更事件
     */
    changeMonth(now) {
      var that = this
      ;(that.jiriTypeName = '全部吉日'),
        (that.jiriType = 4),
        // 设置当前选中月份
        (that.monthChose = now.getMonth() + 1)
      // 设置当前选中年份
      that.yearChose = now.getFullYear()
      // 设置当前时间为1号
      now.setDate(1)
      // 设置开始时间
      var startDate = new Date(JSON.parse(JSON.stringify(now)))
      // 获取选中月份的1号为星期几
      var weekDay = startDate.getDay()
      switch (weekDay) {
        case 1:
          startDate = new Date(JSON.parse(JSON.stringify(now)))
          break
        case 2:
          startDate.setDate(startDate.getDate() - 1)
          break
        case 3:
          startDate.setDate(startDate.getDate() - 2)
          break
        case 4:
          startDate.setDate(startDate.getDate() - 3)
          break
        case 5:
          startDate.setDate(startDate.getDate() - 4)
          break
        case 6:
          startDate.setDate(startDate.getDate() - 5)
          break
        case 0:
          startDate.setDate(startDate.getDate() - 6)
          break
      }
      // 星期天
      if (weekDay == 0) {
        weekDay = 7
      }
      // 设置开始日期
      var startDateStr = startDate.getFullYear()
      // 设置开始日期的月份
      if (startDate.getMonth() + 1 < 10) {
        startDateStr = startDateStr + '0' + (startDate.getMonth() + 1)
      } else {
        startDateStr = startDateStr + '' + (startDate.getMonth() + 1)
      }
      // 设置开始日期的日期
      if (startDate.getDate() < 10) {
        startDateStr = startDateStr + '0' + startDate.getDate()
      } else {
        startDateStr = startDateStr + '' + startDate.getDate()
      }

      var tempDateList = []
      // 上一月补足日期
      for (var i = 0; i < weekDay - 1; i++) {
        var ymdStr = ''
        if (startDate.getMonth() + 1 < 10) {
          ymdStr =
            startDate.getFullYear() +
            '0' +
            (startDate.getMonth() + 1) +
            (startDate.getDate() + i)
        } else {
          ymdStr =
            startDate.getFullYear() +
            '' +
            (startDate.getMonth() + 1) +
            (startDate.getDate() + i)
        }
        var dateItem = {
          ymd: ymdStr, // 年月日：yyyymmdd
          y: startDate.getFullYear(), // 年
          m: startDate.getMonth() + 1, // 月
          d: startDate.getDate() + i, // 日
          isNow: false // 是否为本月
        }
        tempDateList.push(dateItem)
      }

      // 设置结束日期
      var endDate = new Date(JSON.parse(JSON.stringify(now)))
      // 根据年份和月份计算所选月份的天数
      var daysCount = that.countDays(endDate.getFullYear(), endDate.getMonth())
      // 设置选中月份的最后一天
      endDate.setDate(daysCount)
      // 获取选中月份的最后一天为星期几
      var weekDayEnd = endDate.getDay()
      //获取选中月份及上月补足的总天数
      var handerdaysCount = daysCount + tempDateList.length
      //获取列表补齐后的总行数
      var dayslineCount = Math.ceil(handerdaysCount / 7)
      //下月补齐至第一个或第二个
      var nextDaysCount = 1
      // 如果不为星期天，设置结束日期为下个月的第一个星期天或第二个
      if (dayslineCount == 6 && weekDayEnd != 0) {
        nextDaysCount = 1
        endDate.setDate(endDate.getDate() + 7 - weekDayEnd)
      } else if (dayslineCount < 6 && weekDayEnd != 0) {
        nextDaysCount = 2
        endDate.setDate(endDate.getDate() + 14 - weekDayEnd)
      } else if (dayslineCount < 6 && weekDayEnd == 0) {
        nextDaysCount = 6 - dayslineCount
      }

      // 设置结束日期
      var endDateStr = endDate.getFullYear()
      // 设置结束日期的月份
      if (endDate.getMonth() + 1 < 10) {
        endDateStr = endDateStr + '0' + (endDate.getMonth() + 1)
      } else {
        endDateStr = endDateStr + '' + (endDate.getMonth() + 1)
      }
      // 设置结束日期的日期
      if (endDate.getDate() < 10) {
        endDateStr = endDateStr + '0' + endDate.getDate()
      } else {
        endDateStr = endDateStr + '' + endDate.getDate()
      }

      // 设置本月所有日期
      var daysCountNow = that.countDays(now.getFullYear(), now.getMonth())
      for (var j = 1; j <= daysCountNow; j++) {
        var ymdNowStr = ''
        // 设置当前月份的每天的年月
        if (now.getMonth() + 1 < 10) {
          ymdNowStr = now.getFullYear() + '0' + (now.getMonth() + 1)
        } else {
          ymdNowStr = now.getFullYear() + '' + (now.getMonth() + 1)
        }
        // 设置当前月份的每天的日期，小于10补0
        if (j < 10) {
          ymdNowStr += '0' + j
        } else {
          ymdNowStr += '' + j
        }
        var dateItemNow = {
          ymd: ymdNowStr, // 年月日：yyyymmdd
          y: now.getFullYear(), // 年
          m: now.getMonth() + 1, // 月
          d: j, // 日
          isNow: true // 是否为本月
        }
        tempDateList.push(dateItemNow)
      }

      // 下一个月补进日期
      var tempNow = new Date(JSON.parse(JSON.stringify(now)))
      tempNow.setDate(daysCount)
      // 获取选中月最后一天是星期几
      var weekDayEndNext = tempNow.getDay()
      tempNow.setDate(tempNow.getDate() + 1)
      // if (weekDayEndNext != 0) {
      for (var w = 1; w <= nextDaysCount * 7 - weekDayEndNext; w++) {
        var ymdNextStr = ''
        // 月份小于10补0
        if (tempNow.getMonth() + 1 < 10) {
          ymdNextStr =
            tempNow.getFullYear() + '0' + (tempNow.getMonth() + 1) + ('0' + w)
        } else {
          ymdNextStr =
            tempNow.getFullYear() + '' + (tempNow.getMonth() + 1) + ('0' + w)
        }
        var dateItemNext = {
          ymd: ymdNextStr, // 年月日：yyyymmdd
          y: tempNow.getFullYear(), // 年
          m: tempNow.getMonth() + 1, // 月
          d: w, // 日
          isNow: false // 是否为本月
        }
        tempDateList.push(dateItemNext)
      }
      // }
      that.startDateStr = startDateStr
      that.endDateStr = endDateStr
      // 后台API请求数据
      let requestData = {
        startDate: startDateStr,
        endDate: endDateStr,
        choseDate: that.choseDate
      }

      // 获取当月日历信息
      axios
        .post(GLOBAL.getUrlDomain() + 'getBasicCalendarData', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'city-id': that.cityId,
            Authorization: that.token
          }
        })
        .then(
          function(response) {
            var code = response.data.code
            // 成功
            if (code === 0) {
              // 吉日列表
              var auspiciousList = response.data.data.auspiciousList
              // 假日列表
              var holidayList = response.data.data.holidayList
              // 节日列表
              var festivalList = response.data.data.festivalList
              // 收藏信息
              var collectionList = response.data.data.collectionList
              // 选中日期吉日信息
              var chosenAuspiciousList = response.data.data.chosenAuspiciousList
              // 收藏总数
              var collectionCntList = response.data.data.collectionCntList
              // 第一进入画面时取得当前日期
              if (that.firstTime) {
                // 设置选中日期信息
                that.setChosenDateInfo(chosenAuspiciousList)
                that.firstTime = false
              }

              var finalDateList = []
              if (tempDateList && tempDateList.length > 0) {
                for (var i = 0; i < tempDateList.length; i++) {
                  // 年
                  var tempY = parseInt(tempDateList[i].ymd.substr(0, 4))
                  // 月
                  var tempM = parseInt(tempDateList[i].ymd.substr(4, 2))
                  // 日
                  var tempD = parseInt(tempDateList[i].ymd.substr(6, 2))
                  // 获取农历信息
                  tempDateList[i].lunarDate = GLOBAL.getLunarCalendar(
                    tempY,
                    tempM,
                    tempD
                  )
                  // 获取节气信息
                  tempDateList[i].solarDate = GLOBAL.getYearTerm(
                    tempY,
                    tempM,
                    tempD
                  )

                  // 是否为为吉日
                  if (auspiciousList && auspiciousList.length > 0) {
                    for (var j = 0; j < auspiciousList.length; j++) {
                      if (
                        tempDateList[i].ymd == auspiciousList[j].auspiciousDate
                      ) {
                        tempDateList[i].jiriType = auspiciousList[j].jiriType
                        tempDateList[i].isJiri = true
                        break
                      }
                    }
                  }

                  // 是否为节日
                  var isHaveFestival = false
                  if (festivalList && festivalList.length > 0) {
                    var festivalIndex = -1
                    for (var k = 0; k < festivalList.length; k++) {
                      if (tempDateList[i].ymd == festivalList[k].festivalDate) {
                        festivalIndex = k
                        isHaveFestival = true
                        break
                      }
                    }
                    // 如果是节日，设置节日名称并将字体颜色标红
                    if (
                      isHaveFestival &&
                      festivalList[festivalIndex].festivalName
                    ) {
                      tempDateList[i].finalDateDescribe =
                        festivalList[festivalIndex].festivalName
                      tempDateList[i].redFlg = 0
                    }
                  }

                  // 是否已收藏
                  if (collectionList && collectionList.length > 0) {
                    for (var n = 0; n < collectionList.length; n++) {
                      if (
                        tempDateList[i].ymd == collectionList[n].collectionDate
                      ) {
                        tempDateList[i].collectionId =
                          collectionList[n].collectionId
                        break
                      }
                    }
                  }

                  // 收藏总数
                  if (collectionCntList && collectionCntList.length > 0) {
                    if (collectionCntList.length > 99) {
                      that.collectionCnt = '99+'
                      that.collectionCntType = 3
                    } else {
                      that.collectionCnt = collectionCntList.length
                      that.collectionCntType = 2
                    }
                  } else {
                    that.collectionCnt = 0
                    that.collectionCntType = 1
                  }

                  // 如果不为节日
                  if (!isHaveFestival) {
                    var lunarFes = GLOBAL.getLunarFestival(
                      tempDateList[i].lunarDate.month +
                        tempDateList[i].lunarDate.day
                    )
                    if (lunarFes) {
                      tempDateList[i].finalDateDescribe = lunarFes
                      tempDateList[i].redFlg = 0
                      // 如果有节气存在，显示节气名称
                    } else if (tempDateList[i].solarDate) {
                      tempDateList[i].finalDateDescribe =
                        tempDateList[i].solarDate
                      tempDateList[i].redFlg = 0
                      // 显示阴历日期
                    } else {
                      tempDateList[i].finalDateDescribe =
                        tempDateList[i].lunarDate.day
                      tempDateList[i].redFlg = 0
                    }
                  }

                  // 是否为假日
                  if (holidayList && holidayList.length > 0) {
                    for (var l = 0; l < holidayList.length; l++) {
                      if (tempDateList[i].ymd == holidayList[l].holidayDate) {
                        if (holidayList[l].holidayFlag == 1) {
                          tempDateList[i].redFlg = 1
                        }
                        break
                      }
                    }
                  }

                  // 如果和选中日期相同
                  if (that.choseDate == tempDateList[i].ymd) {
                    var tChoseDate = that.chosenDateItem
                    if (
                      tempDateList[i].lunarDate.day ==
                      tempDateList[i].finalDateDescribe
                    ) {
                      tChoseDate.finalDateDescribe =
                        tempDateList[i].lunarDate.month +
                        tempDateList[i].lunarDate.day
                    } else {
                      tChoseDate.finalDateDescribe =
                        tempDateList[i].finalDateDescribe
                    }
                    if (
                      tempDateList[i].collectionId &&
                      tempDateList[i].collectionId != 0
                    ) {
                      tChoseDate.isCollection = 1
                    } else {
                      tChoseDate.isCollection = 0
                    }
                    that.chosenDateItem = tChoseDate
                  }

                  finalDateList.push(tempDateList[i])
                }
              }
              // 设置选中月份的所有日期信息
              that.dateList = finalDateList

              // 刷新收藏图标
              that.dateTap(that.choseDate, true)
              that.isLoading = false
            } else if (code === -1) {
              console.log(response.data.message)
              that.isLoading = false
            }
          }.bind(this)
        )
        .catch(function(response) {
          that.isLoading = false
          // 这里是处理错误的回调
          console.log(response)
        })
    },

    /**
     * 设置选中日期信息
     */
    setChosenDateInfo(chosenAuspiciousList) {
      var that = this
      // 设置基本字段信息
      var tmpChosenDateItem = {
        yiji1: 3,
        yiji2: 3,
        yiji3: 3,
        yiji4: 3,
        yiji5: 3,
        isCollection: 0,
        finalDateDescribe: ''
      }
      // 选中日期的年月信息
      tmpChosenDateItem.yaerMonth =
        that.choseDate.substr(0, 4) + '年' + that.choseDate.substr(4, 2) + '月'
      // 选中日期
      tmpChosenDateItem.date = that.choseDate.substr(6, 2)

      var choseDay = new Date()
      // 设置日期类型的选中日期
      choseDay.setFullYear(parseInt(that.choseDate.substr(0, 4)))
      choseDay.setMonth(parseInt(that.choseDate.substr(4, 2)) - 1)
      choseDay.setDate(parseInt(that.choseDate.substr(6, 2)))
      // 获取选中日期的星期信息
      var choseWeekDay = choseDay.getDay()
      switch (choseWeekDay) {
        case 1:
          tmpChosenDateItem.weekStr = '星期一'
          break
        case 2:
          tmpChosenDateItem.weekStr = '星期二'
          break
        case 3:
          tmpChosenDateItem.weekStr = '星期三'
          break
        case 4:
          tmpChosenDateItem.weekStr = '星期四'
          break
        case 5:
          tmpChosenDateItem.weekStr = '星期五'
          break
        case 6:
          tmpChosenDateItem.weekStr = '星期六'
          break
        case 0:
          tmpChosenDateItem.weekStr = '星期日'
          break
        default:
          break
      }
      // 年
      var tempY = parseInt(that.choseDate.substr(0, 4))
      // 月
      var tempM = parseInt(that.choseDate.substr(4, 2))
      // 日
      var tempD = parseInt(that.choseDate.substr(6, 2))
      // 获取农历信息
      tmpChosenDateItem.lunarDate = GLOBAL.getLunarCalendar(tempY, tempM, tempD)
      // 获取节气信息
      tmpChosenDateItem.solarDate = GLOBAL.getYearTerm(tempY, tempM, tempD)
      // 选中日期的吉日信息
      if (chosenAuspiciousList && chosenAuspiciousList.length > 0) {
        for (var i = 0; i < chosenAuspiciousList.length; i++) {
          switch (chosenAuspiciousList[i].jiriType) {
            // 嫁娶吉日
            case '0':
              // 吉
              if (chosenAuspiciousList[i].yijiType == 1) {
                tmpChosenDateItem.yiji1 = 1
                // 忌
              } else if (chosenAuspiciousList[i].yijiType == 2) {
                tmpChosenDateItem.yiji1 = 2
              }
              break
            // 订婚吉日
            case '1':
              // 吉
              if (chosenAuspiciousList[i].yijiType == 1) {
                tmpChosenDateItem.yiji2 = 1
                // 忌
              } else if (chosenAuspiciousList[i].yijiType == 2) {
                tmpChosenDateItem.yiji2 = 2
              }
              break
            // 彩礼吉日
            case '2':
              // 吉
              if (chosenAuspiciousList[i].yijiType == 1) {
                tmpChosenDateItem.yiji3 = 1
                // 忌
              } else if (chosenAuspiciousList[i].yijiType == 2) {
                tmpChosenDateItem.yiji3 = 2
              }
              break
            // 纳婿吉日
            case '3':
              // 吉
              if (chosenAuspiciousList[i].yijiType == 1) {
                tmpChosenDateItem.yiji4 = 1
                // 忌
              } else if (chosenAuspiciousList[i].yijiType == 2) {
                tmpChosenDateItem.yiji4 = 2
              }
              break
            // 领证吉日
            case '5':
              // 吉
              if (chosenAuspiciousList[i].yijiType == 1) {
                tmpChosenDateItem.yiji5 = 1
                // 忌
              } else if (chosenAuspiciousList[i].yijiType == 2) {
                tmpChosenDateItem.yiji5 = 2
              }
              break
            default:
              break
          }
        }
      } else {
        // 忌嫁娶
        tmpChosenDateItem.yiji1 = 3
        // 忌订婚
        tmpChosenDateItem.yiji2 = 3
        // 忌彩礼
        tmpChosenDateItem.yiji3 = 3
        // 忌纳婿
        tmpChosenDateItem.yiji4 = 3
        // 忌领证
        tmpChosenDateItem.yiji5 = 3
      }
      // 设置选中日期信息
      that.chosenDateItem = tmpChosenDateItem
    },

    /**
     * 日期选择器确定事件
     */
    handlePickerConfirm(dateData) {
      var that = this
      // 设置选中年月的下标
      that.anchor = [dateData[0].index, dateData[1].index]
      var now = new Date()
      now.setDate(1)
      now.setFullYear(dateData[0].value.substr(0, 4))
      // 设置选中年份
      that.yearChose = dateData[0].value.substr(0, 4)
      // 月份小于10的情况设置月份
      if (dateData[1].index < 9) {
        now.setMonth(dateData[1].value.substr(0, 1) - 1)
        that.monthChose = dateData[1].value.substr(0, 1)
        // 月份大于等于10的情况设置月份
      } else {
        now.setMonth(dateData[1].value.substr(0, 2) - 1)
        that.monthChose = dateData[1].value.substr(0, 2)
      }
      // 月份变更事件
      that.changeMonth(now)
      ;(that.jiriTypeName = '全部吉日'), (that.jiriType = 4)
    },

    /**
     * 显示日期选择器
     */
    showDatePicker: function() {
      var that = this
      // 显示日期选择器
      that.$refs.picker.show()
    },

    /**
     * 点击日历中的日期
     */
    dateTap(ymd, isNow) {
      var that = this
      // 设置当前选中日期
      that.choseDate = ymd
      // 后台API请求参数
      let requestData = {
        choseDate: that.choseDate
      }
      // 不是本月
      if (!isNow) {
        var choseNow = ''
        // 设置年月
        if (that.monthChose < 10) {
          choseNow = that.yearChose + '0' + that.monthChose
        } else {
          choseNow = that.yearChose + '' + that.monthChose
        }
        // 如果选中年月比当前月份小,向右滑动处理,翻页到前一个月
        if (parseInt(ymd.substr(0, 6)) < parseInt(choseNow)) {
          that.firstTime = true
          that.onSwipeRight()
          // 如果选中年月比当前月份大,向左滑动处理,翻页到下一个月
        } else {
          that.firstTime = true
          that.onSwipeLeft()
        }
      }
      // 获取选中日期信息
      axios
        .post(GLOBAL.getUrlDomain() + 'getDateInfo', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'city-id': that.cityId,
            Authorization: that.token
          }
        })
        .then(function(response) {
          var code = response.data.code
          // 成功
          if (code === 0) {
            // 吉日信息
            var chosenAuspiciousList = response.data.data.chosenAuspiciousList
            // 节日信息
            var festivalList = response.data.data.festivalList
            // 收藏信息
            var collectionList = response.data.data.collectionList
            // 设置选中日期信息
            that.setChosenDateInfo(chosenAuspiciousList)

            var tChoseDate = that.chosenDateItem
            // 设置节日、节气、农历的显示效果
            if (festivalList && festivalList.length > 0) {
              tChoseDate.finalDateDescribe = festivalList[0].festivalName
            } else {
              var lunarFes = GLOBAL.getLunarFestival(
                tChoseDate.lunarDate.month + tChoseDate.lunarDate.day
              )
              if (lunarFes) {
                tChoseDate.finalDateDescribe = lunarFes
              } else if (tChoseDate.solarDate) {
                tChoseDate.finalDateDescribe = tChoseDate.solarDate
              } else {
                tChoseDate.finalDateDescribe =
                  tChoseDate.lunarDate.month + tChoseDate.lunarDate.day
              }
            }

            // 是否收藏
            if (collectionList && collectionList.length > 0) {
              tChoseDate.collectionId = collectionList[0].collectionId
              if (
                collectionList[0].collectionId &&
                collectionList[0].collectionId != 0
              ) {
                tChoseDate.isCollection = 1
              } else {
                tChoseDate.isCollection = 0
              }
            } else {
              tChoseDate.isCollection = 0
            }
            // 设置选中日期信息
            that.chosenDateItem = tChoseDate
            // 失败
          } else if (code === -1) {
            console.log(response.data.message)
          }
        })
        .catch(function(response) {
          // 这里是处理错误的回调
          console.log(response)
        })
    },

    /**
     * 向左滑动日历，翻页至下一个月
     */
    onSwipeLeft() {
      var that = this
      that.isCalendarShow = false

      //执行切换页面的方法
      var monthTemp = that.monthChose + 1
      var yearTemp = that.yearChose
      // 如果下一个月为下一年年，设置年月
      if (monthTemp > 12) {
        monthTemp = monthTemp - 12
        yearTemp = yearTemp + 1
      }
      // 如果下个月超过最大选择时间2025年12月，不做翻页处理
      if (yearTemp > 2025) {
        that.isCalendarShow = true
        return
      }
      // 设置当前选中月份
      that.monthChose = monthTemp
      // 设置当前选中年份
      that.yearChose = yearTemp

      var now = new Date()
      now.setDate(1)
      now.setFullYear(that.yearChose)
      now.setMonth(that.monthChose - 1)
      // 设置当前所选月份
      that.setChoseMonth(now)
      // 月份变更事件
      that.changeMonth(now)
      ;(that.jiriTypeName = '全部吉日'), (that.jiriType = 4)
      that.isCalendarShow = true
    },

    /**
     * 向上滑动日历，滑动至页面底部
     */
    onSwipeUp() {
      // 滑动至页面底部
      document.getElementById('jiriInfoRef').scrollIntoView(true)
    },

    /**
     * 向下滑动日历，滑动至页面顶部
     */
    onSwipeDown() {
      // 滑动至页面顶部
      document.body.scrollTop = 0
      //兼容处理滑动至顶部
      document.documentElement.scrollTop = 0
    },

    /**
     * 向右滑动日历，翻页至前一个月
     */
    onSwipeRight() {
      var that = this
      that.isCalendarShow = false

      //执行切换页面的方法
      var monthTemp = that.monthChose - 1
      var yearTemp = that.yearChose
      // 如果上一个月为前一年年，设置年月
      if (monthTemp < 1) {
        monthTemp = monthTemp + 12
        yearTemp = yearTemp - 1
      }
      // 如果上个月超过最小选择时间2018年1月，不做翻页处理
      if (yearTemp < 2018) {
        that.isCalendarShow = true
        return
      }
      // 设置当前选中月份
      that.monthChose = monthTemp
      // 设置当前选中年份
      that.yearChose = yearTemp

      var now = new Date()
      now.setDate(1)
      now.setFullYear(that.yearChose)
      now.setMonth(that.monthChose - 1)
      // 设置当前所选月份
      that.setChoseMonth(now)
      // 月份变更事件
      that.changeMonth(now)
      ;(that.jiriTypeName = '全部吉日'), (that.jiriType = 4)
      that.isCalendarShow = true
    },

    /**
     * 收藏处理
     */
    doCollection() {
      var that = this
      // 判断是否在app内打开，如果不是提示'请在app内操作'
      if (!browers().isApp) {
        this.showMask = false
        this.showdownloadpop = true
        // location.replace(
        //   'https://www.jiehun.com.cn/mobile/download/?app_channel=JHJR_qgscjr'
        // )
        return
      }
      // 未登录
      if (!that.token) {
        // 设置未登录提示信息
        that.collectionMessage = '您还未登录，请先登录!'
        // 显示未登录信息提示弹窗
        that.collectionPopShow = true
        // 1秒后自动关闭收藏信息提示弹窗
        setTimeout(that.closeCollectionPop, 1000)
        // TODO 调用登录画面
        return
      }

      // 后台API请求参数
      let requestData = {
        choseDate: that.choseDate
      }
      // 点击收藏相关处理
      axios
        .post(GLOBAL.getUrlDomain() + 'doCollection', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'city-id': that.cityId,
            Authorization: that.token
          }
        })
        .then(
          function(response) {
            var code = response.data.code
            // 成功
            if (code === 0) {
              var ret = response.data.data
              // 设置当前收藏总数
              var tempCollectionCnt = ret.collectionCnt
              // 收藏数99+
              if (tempCollectionCnt > 99) {
                that.collectionCnt = '99+'
                that.collectionCntType = 3
                // 收藏数1~99
              } else if (tempCollectionCnt > 0) {
                that.collectionCnt = tempCollectionCnt
                that.collectionCntType = 2
                // 未收藏
              } else {
                that.collectionCnt = 0
                that.collectionCntType = 1
              }
              // 收藏成功
              if (ret.code == 0) {
                var chosenItem = this.chosenDateItem
                // 设置当前是否收藏 0:未收藏 1:收藏
                chosenItem.isCollection = 1
                // 设置选中日期信息
                this.chosenDateItem = chosenItem
                // 将日历中的选中日期标记上收藏图标
                for (var t = 0; t < that.dateList.length; t++) {
                  if (that.dateList[t].ymd == that.choseDate) {
                    that.dateList[t].collectionId = 1
                    break
                  }
                }
                // 刷新图标
                that.dateTap(that.choseDate, true)
                // 设置收藏成功显示信息
                that.collectionMessage = '收藏成功'
                // 显示收藏信息提示弹窗
                that.collectionPopShow = true
                // 1秒后自动关闭收藏信息提示弹窗
                setTimeout(that.closeCollectionPop, 1000)
                // 取消收藏
              } else if (ret.code == 1) {
                var chosenItemTmp = this.chosenDateItem
                // 设置当前是否收藏 0:未收藏 1:收藏
                chosenItemTmp.isCollection = 0
                // 设置选中日期信息
                this.chosenDateItem = chosenItemTmp
                // 将日历中的选中日期去除收藏图标
                for (var i = 0; i < that.dateList.length; i++) {
                  if (that.dateList[i].ymd == that.choseDate) {
                    that.dateList[i].collectionId = 0
                    break
                  }
                }
                // 刷新图标
                that.dateTap(that.choseDate, true)
                // 设置取消收藏显示信息
                that.collectionMessage = '取消收藏成功'
                // 设置取消收藏显示信息
                that.collectionPopShow = true
                // 1秒后自动关闭收藏信息提示弹窗
                setTimeout(that.closeCollectionPop, 1000)
              }

              // 失败
            } else if (code === -1) {
              // 设置取消收藏显示信息
              that.overrunMessage = response.data.message
              // 设置取消收藏显示信息
              that.overrunPopShow = true
              // 1秒后自动关闭收藏信息提示弹窗
              setTimeout(that.closeOverrunPop, 1000)
              console.log(response.data.message)
            }
          }.bind(this)
        )
        .catch(function(response) {
          // 这里是处理错误的回调
          console.log(response)
        })
    },
    /**
     * 关闭收藏信息提示弹窗
     */
    closeCollectionPop() {
      var that = this
      that.collectionMessage = ''
      that.collectionPopShow = false
    },
    /**
     * 关闭收藏信息提示弹窗
     */
    closeOverrunPop() {
      var that = this
      that.overrunMessage = ''
      that.overrunPopShow = false
    },
    /**
     * 判断是否双休日
     */
    isHoliday(index) {
      return (index + 1 - 6) % 7 == 0 || (index + 1) % 7 == 0
    },
    postData(acName, url, href) {
      //事件日志上报
      let params = {
        actionName: acName,
        actionValue: url
      }
      window.$action.h_actionDatas(params).then(() => {
        href && (location.href = href)
      })
    }
  }
}
</script>

<style>
body {
  background-color: #f5f8fa;
}
.calendar-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f8fa;
  font-family: 'PingFangSC-Regular';
}

.top-blank-div {
  width: 100%;
  height: 5rem;
  scroll-behavior: unset;
}
.calendar-head-line {
  min-height: 5rem;
  width: 100%;
  display: block;
  position: fixed;
  top: 0rem;
  left: 0rem;
  z-index: 999;
}
.calendar-title-line {
  width: 100%;
  height: 4.9rem;
  display: flex;
  position: relative;
  background-color: rgba(255, 59, 80, 1);
  z-index: 999;
}

.calendar-flex-div {
  margin-left: auto;
  margin-right: auto;
}

.calendar-back-icon {
  position: absolute;
  width: 1.8rem;
  height: 1.8rem;
  top: 1.6rem;
  left: 1.5rem;
}

.calendar-date-pick {
  height: 4.9rem;
  line-height: 4.9rem;
  margin-left: 1.5rem;
  color: white;
  font-size: 1.7rem;
  float: left;
  font-family: 'PingFangSC-Medium';
}

.calendar-date-pick-area {
  width: 5rem;
  height: 4.9rem;
  float: left;
}

.calendar-date-pick-img {
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 1.75rem;
  margin-left: 0.5rem;
  float: left;
}
.calendar-date-pick-img-rigth {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 1.75rem;
  margin-left: 0.5rem;
  float: right;
}

.calendar-area {
  width: 100%;
  background-color: white;
}

.calendar-auspicious-list {
  position: absolute;
  font-family: 'PingFangSC-Medium';
  height: 5rem;
  line-height: 5rem;
  color: white;
  font-size: 1.4rem;
  right: 2.2rem;
  top: 0rem;
}

.calendar-week-title-line {
  width: 36.5rem;
  height: 3.3rem;
  font-family: 'PingFangSC-Regular';
  line-height: 1.65rem;
  text-align: center;
  margin-left: 0.8rem;
  display: flex;
  font-size: 1.2rem;
  margin-bottom: -0.8rem;
}

.calendar-week-title {
  width: 4.5rem;
  height: 1.65rem;
  /* margin-right: 0.2rem; */
  color: #999999;
  margin-right: 0.68rem;
  margin-top: 1.5rem;
}

.calendar-week-title-weekend {
  width: 4.5rem;
  height: 1.65rem;
  color: #ff3b50;
  margin-right: 0.68rem;
  margin-top: 1.5rem;
}

.calendar-month-date-area {
  width: 36.5rem;
  margin-left: 0.8rem;
  font-size: 1.4rem;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  background-color: white;
  padding-bottom: 1.5rem;
}

.calendar-date-info-area {
  width: 34.5rem;
  height: 12.25rem;
  background-color: white;
  border-radius: 1.5rem;
  margin-left: 1.5rem;
  margin-top: 1.5rem;
}
.calendar-date-info-area2 {
  width: 34.5rem;
  height: 8.5rem;
  background-color: white;
  border-radius: 1.5rem;
  margin-left: 1.5rem;
  margin-top: 0.2rem;
  margin-bottom: 2rem;
  position: relative;
}
.book-chain-left {
  position: absolute;
  left: 1.05rem;
  top: -1.5rem;
  height: 2.7rem;
  width: 1.2rem;
}
.book-chain-right {
  position: absolute;
  right: 1.05rem;
  top: -1.5rem;
  height: 2.7rem;
  width: 1.2rem;
}
.book-chain-icon {
  height: 2.7rem;
  width: 1.2rem;
}
.date-info-line1 {
  position: relative;
  width: 33rem;
  height: 6.4rem;
  display: flex;
  margin-left: 1.5rem;
}
.date-info-line1-left {
  display: flex;
  margin-top: 2.2rem;
}
.date-info-line1-right {
  width: 15rem;
  height: 7.3rem;
  margin-top: 0.4rem;
  margin-right: 1.65rem;
  position: absolute;
  right: 0;
}
.date-info-date-text {
  width: 6rem;
  height: 3.65rem;
  font-size: 5rem;
  line-height: 3.65rem;
  text-align: left;
  color: #333333;
}

.date-info-detail-area {
  height: 4.4rem;
}

.date-info-lanur-date {
  height: 1.45rem;
  font-size: 1.5rem;
  color: #333333;
  line-height: 2rem;
  line-height: 1.45rem;
  opacity: 0.9;
}

.date-info-week-detail {
  height: 1rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.91rem;
  font-size: 1rem;
  margin-top: 1.3rem;
}

.date-info-collection-area-1 {
  width: 12rem;
  height: 4rem;
  border-radius: 2rem;
  margin-left: 3rem;
  margin-top: 0.2rem;
  display: flex;
  background-color: #fbfbfb;
}

.date-info-collection-area-2 {
  width: 13.5rem;
  height: 4rem;
  border-radius: 2rem;
  margin-left: 1.5rem;
  margin-top: 0.2rem;
  display: flex;
  background-color: #fbfbfb;
}

.date-info-collection-area-3 {
  width: 14.5rem;
  height: 4rem;
  border-radius: 2rem;
  margin-left: 0.5rem;
  margin-top: 0.2rem;
  display: flex;
  background-color: #fbfbfb;
}

.date-info-collection-div {
  width: 2.6rem;
  height: 2.6rem;
  margin-left: 0.7rem;
  margin-top: 0.7rem;
  background-color: #ffffff;
  border-radius: 1.3rem;
}

.date-info-collection-icon {
  width: 2rem;
  height: 2rem;
  margin-top: 0.3rem;
  margin-left: 0.3rem;
}

.sure-line {
  width: 1px;
  height: 1.2rem;
  background-color: #eeeeee;
  margin-right: 0.7rem;
  margin-left: 0.7rem;
  margin-top: 0.5rem;
}

.date-info-collection-text {
  height: 2rem;
  font-size: 1.4rem;
  color: #333333;
  font-family: 'PingFang SC';
  line-height: 2rem;
  margin-top: 1rem;
  margin-left: 0.5rem;
}
.date-info-collection-area {
  height: 1.8rem;
  display: flex;
  position: absolute;
  right: 4.7rem;
}

.date-info-collection-area-app {
  height: 1.8rem;
  display: flex;
}

.date-info-collection-count {
  height: 1.8rem;
  font-size: 1.4rem;
  color: #333333;
  line-height: 1.8rem;
  font-family: 'PingFang SC';
  color: #ff6363;
  margin-top: 0.25rem;
}

.date-info-collection-count-app {
  height: 1.8rem;
  font-size: 1.4rem;
  color: #333333;
  line-height: 1.8rem;
  font-family: 'PingFang SC';
  color: #ff6363;
  margin-top: 0.25rem;
  margin-left: 0.1rem;
}

.date-info-collection-right-icon {
  width: 0.6rem;
  height: 1.1rem;
  margin-top: 0.6rem;
  margin-left: 0.3rem;
}

.date-info-collection-right-icon-app {
  width: 0.6rem;
  height: 1.13rem;
  margin-top: 0.45rem;
  margin-left: 0.3rem;
}

.date-info-line2 {
  position: relative;
  width: 33rem;
  height: 3.8rem;
  display: flex;
  padding-left: 1.5rem;
  margin-top: 2rem;
}
.date-info-line2-app {
  position: relative;
  width: 33rem;
  height: 3.8rem;
  display: flex;
  padding-left: 1.5rem;
  margin-top: 2rem;
}
.date-info-yiji-right {
  height: 3rem;
  display: flex;
  float: right;
}
.date-info-yiji-left {
  height: 3rem;
  display: flex;
  margin-right: 2.7rem;
  float: right;
}
.date-info-yiji-icon {
  width: 2.2rem;
  height: 2.2rem;
  margin-top: 0.8rem;
  margin-right: 0.3rem;
  border-radius: 50%;
  float: left;
}

.date-info-yiji-text {
  height: 2.2rem;
  font-size: 1.4rem;
  color: #333333;
  line-height: 2.2rem;
  font-weight: bold;
  margin-top: 0.8rem;
  float: left;
}

.calendar-margin-right-2 {
  /* margin-right: 2rem; */
}

.date-info-line3 {
  width: 34.5rem;
  height: 8.8rem;
  display: flex;
}
.date-info-hotel {
  width: 15rem;
  height: 4.4rem;
  margin: 2.05rem auto;
  position: relative;
  background: linear-gradient(90deg, #ff3b50, #ff5542);
  border-radius: 2.2rem;
}
.date-info-hotel-btnImg {
  width: 4rem;
  height: 4rem;
  margin: 0.2rem;
}
.date-info-hotel-text {
  position: absolute;
  top: 0;
  left: 0;
  height: 4.4rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 4.4rem;
  margin-left: 5.8rem;
}
.date-info-hotel-hot {
  position: absolute;
  top: 0;
  right: -0.6rem;
  width: 3.5rem;
  height: 1.6rem;
  background: linear-gradient(90deg, #5c99f8, #85b4fd);
  border-radius: 0.8rem;
  font-size: 1.1rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 1.6rem;
  text-align: center;
}
.date-info-function-icon {
  width: 1.5rem;
  height: 1.4rem;
  margin-right: 0.15rem;
  margin-top: 0.3rem;
  margin-left: 3.2rem;
}

.date-info-function-icon-app {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.4rem;
  margin-top: 0.2rem;
  margin-left: 0.4rem;
}

.date-info-function-text {
  height: 2rem;
  font-size: 1.4rem;
  color: #333333;
  line-height: 2rem;
  margin-left: 0.2rem;
}

.date-info-function-text-app {
  height: 1.8rem;
  font-size: 1.4rem;
  color: #333333;
  line-height: 1.8rem;
  width: 5.7rem;
}

.date-info-function-icon-no-share-left {
  width: 1.8rem;
  height: 1.8rem;
  margin-top: 0.25rem;
  margin-right: 0.5rem;
  margin-left: 3.4rem;
}
.date-info-function-icon-leftOne {
  width: 1.8rem;
  height: 1.8rem;
  margin-top: 0.25rem;
  margin-right: 0.5rem;
  margin-left: 0.4rem;
}

.date-info-function-icon-no-share-right {
  width: 1.8rem;
  height: 1.8rem;
  margin-top: 0.25rem;
  margin-right: 0.5rem;
}

.date-info-function-text-no-share {
  width: 5.6rem;
  height: 3.5rem;
  font-size: 1.4rem;
  color: #333333;
  line-height: 2.55rem;
}

.sure-line-no-share {
  width: 1px;
  height: 1.2rem;
  background-color: #eeeeee;
  position: absolute;
  left: 50%;
  margin-top: 0.6rem;
}

.margin-left-first {
  margin-left: 0.2rem;
}

.margin-right-4-5 {
  margin-right: 2rem !important;
}

.share-width {
  width: 7rem;
}

.margin-left-4-5-app {
  margin-left: 0.2rem !important;
  width: 1.4rem;
  height: 1.4rem;
}

.ji-icon {
  position: absolute;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  background-image: url('../../../assets/jiIcon.png');
  background-repeat: no-repeat;
  background-color: #ff3b50;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

.collection-icon {
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background-image: url('../../../assets/collectionSelectedSmallRep.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

.bold-font {
  width: 4.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  padding-left: 0rem;
  text-align: center;
  padding-top: 0.3rem;
}

.p-style-holiday {
  color: #ff3b50;
  font-size: 1rem;
  height: 1rem;
  line-height: 1rem;
  margin: 0;
  text-align: center;
  width: 4.5rem !important;
}

.p-style {
  color: rgb(140, 140, 140);
  font-size: 1rem;
  line-height: 1rem;
  height: 1rem;
  margin: 0;
}

.p-style-grey {
  color: #cccccc;
  font-size: 1rem;
  line-height: 1rem;
  height: 1rem;
  margin: 0;
}

.p-style-selected {
  color: white;
  font-size: 1rem;
  line-height: 1rem;
  height: 1rem;
  margin: 0;
}

.date-info-cell {
  width: 4.5rem;
  height: 4.5rem;
  margin-right: 0.7rem;
  text-align: center;
  color: #333333;
  line-height: 3rem;
  font-size: 1.6rem;
  margin-top: 1rem;
}

.date-info-cell-grey {
  width: 4.5rem;
  height: 4.5rem;
  margin-right: 0.7rem;
  text-align: center;
  line-height: 3rem;
  font-size: 1.6rem;
  margin-top: 1rem;
  color: #cccccc !important;
}

.date-info-cell-selected {
  border-radius: 50%;
  background-color: rgba(255, 59, 80, 1);
  width: 4.5rem;
  height: 4.5rem;
  margin-right: 0.7rem;
  color: white;
  text-align: center;
  line-height: 3rem;
  font-size: 1.6rem;
  margin-top: 1rem;
}

.date-info-cell-select {
  border-radius: 50%;
  background-color: rgba(255, 59, 80, 1);
  width: 4.5rem;
  height: 4.5rem;
  margin-right: 0.7rem;
  color: white;
  text-align: center;
  line-height: 3rem;
  font-size: 1.6rem;
  margin-top: 1rem;
}

.date-info-holiday-cell-selected {
  border-radius: 50%;
  border: 0.05rem solid #ff9292;
  width: 4.4rem;
  height: 4.4rem;
  margin-right: 0.7rem;
  color: #ff6363;
  text-align: center;
  line-height: 3rem;
  font-size: 1.6rem;
  margin-top: 1rem;
}

.date-info-holiday-cell {
  width: 4.5rem;
  height: 4.5rem;
  margin-right: 0.7rem;
  color: #333333;
  text-align: center;
  line-height: 3rem;
  font-size: 1.6rem;
  margin-top: 1rem;
}

.month-input {
  width: 7.5rem;
  height: 3rem;
  float: left;
}

.date-picker {
  width: 100%;
  height: 13rem;
}

.date-picker-area {
  width: 100%;
  height: 17rem;
  position: fixed;
  left: 0rem;
  bottom: 0rem;
}

.date-picker-column {
  text-align: center;
}

.data-picker-sure-line {
  width: 100%;
  height: 4rem;
  line-height: 3rem;
  color: #ff9292;
  font-size: 1.6rem;
}

.data-pick-cancel {
  width: 4rem;
  text-align: center;
  height: 3rem;
  float: left;
  margin-left: 2rem;
}

.data-pick-sure {
  width: 4rem;
  text-align: center;
  height: 3rem;
  float: right;
  margin-right: 2rem;
}

.collection-message-pop {
  width: 20rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-family: 'PingFangSC-Regular';
  border-radius: 1rem;
  color: #f5f8fa;
  font-size: 1.6rem;
  position: fixed;
  top: 33.5rem;
  left: 8.75rem;
  background-color: #333333;
  opacity: 0.9;
}

.overrun-message-pop {
  width: 25rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-family: 'PingFangSC-Regular';
  border-radius: 1rem;
  color: #f5f8fa;
  font-size: 1.6rem;
  position: fixed;
  top: 33.5rem;
  left: 6.25rem;
  background-color: #333333;
  opacity: 0.9;
}

.app-message-pop {
  width: 20rem;
  height: 6rem;
  line-height: 3rem;
  padding: 2rem;
  text-align: center;
  font-family: 'PingFangSC-Regular';
  border-radius: 1rem;
  color: #f5f8fa;
  font-size: 1.5rem;
  position: fixed;
  top: 33.5rem;
  left: 6.75rem;
  background-color: #333333;
  opacity: 0.9;
}

.pt-cancel {
  font-size: 1.6rem !important;
}

.pt-submit {
  font-size: 1.6rem !important;
}

.picker-title {
  background-color: #f5f8fa !important;
}

.picker-title::after {
  border-bottom: 0rem solid white !important;
}

body {
  display: block;
  margin: 0rem !important;
}

.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 50rem;
  font-size: 2rem;
  color: grey;
}

.download-line {
  width: 100%;
  height: 5rem;
  background: url('../../../assets//downbg.png') no-repeat;
  background-size: 100%;
  position: relative;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.download-close-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-left: 1.5rem;
  margin-right: 1rem;
}

.download-app-img {
  width: 6.7rem;
  height: 2rem;
}

.download-text {
  width: 20rem;
  height: 2rem;
  margin-left: 1rem;
  color: #ffffff;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
}

.download-btn {
  width: 7rem;
  height: 3rem;
  border-radius: 1.5rem;
  font-size: 1.5rem;
  line-height: 3rem;
  background: linear-gradient(180deg, #ffffff 0%, #ffd5db 100%);
  font-weight: 500;
  color: #ff3a5b;
  text-align: center;
}

.downloadpop {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.popbox {
  width: 30rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  text-align: center;
  border-radius: 0.8rem;
}
.popbox .poptext {
  text-align: left;
  color: #222222;
  font-size: 1.5rem;
  text-align: center;
  white-space: break-spaces;
  border-bottom: 0.3333px solid #e5e5e5;
  padding: 2rem;
  margin: 0;
}
.popbox .pop_btn {
  height: 5rem;
  color: #fff;
  font-size: 1.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popbox .popleftbtn {
  color: #999999;
  font-size: 1.7rem;
  width: 50%;
  height: 5rem;
  line-height: 5rem;
}
.popbox .poprightbtn {
  border-left: 0.3333px solid #e5e5e5;
  color: #ff3a5b;
  font-size: 1.7rem;
  width: 50%;
  height: 5rem;
  line-height: 5rem;
}
.mask-open {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.1);
}

.message-box {
  position: fixed;
  top: 1.2rem;
  right: 1.2rem;
  z-index: 1001;
  width: 20rem;
  padding: 0.8rem;
  border-radius: 0.4rem;
  background-color: #fff;
  font-size: 1.6rem;
  color: #666;
}

.message-box .samp {
  position: absolute;
  border-color: transparent transparent #fff;
  border-style: none solid solid;
  border-width: medium 0.4rem 0.4rem;
  display: block;
  left: 90%;
  top: -0.4rem;
}

/*  */
.jiri-title-line {
  height: 5rem;
  width: 36rem;
  background-color: #ff6363;
  color: white;
  font-size: 1.7rem;
  font-family: 'PingFangSC-Medium';
  line-height: 5rem;
  text-align: left;
  padding-left: 1.5rem;
  position: fixed;
  top: 0rem;
  left: 0rem;
}
.condition-text-select {
  position: absolute;
  height: 4.9rem;
  font-size: 1.4rem;
  font-weight: normal;
  color: white;
  font-family: 'PingFangSC-Medium';
  line-height: 4.9rem;
  text-align: center;
  top: 0rem;
  right: 2rem;
}
.condition-text-down-area {
  position: absolute;
  top: 0rem;
  right: 2rem;
  width: 1.5rem;
  height: 5rem;
}
.condition-text-down {
  width: 1.5rem;
  height: 1.5rem;
  margin-top: 1.75rem;
}
.pop-background {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0rem;
  left: 0rem;
  background-color: black;
  opacity: 0.4;
  z-index: 101;
}
.rectangle {
  position: absolute;
  right: 3rem;
  top: 4rem;
  width: 0;
  height: 0;
  border-width: 1rem;
  border-style: solid;
  border-color: transparent transparent white transparent;
  z-index: 102;
}

.condition-area {
  position: absolute;
  right: 1rem;
  top: 5.6rem;
  width: 12rem;
  height: 24.3rem;
  background-color: white;
  opacity: 1;
  border-radius: 0.5rem;
  z-index: 102;
}

.condition-tab-selected {
  width: 11rem;
  height: 4rem;
  line-height: 4rem;
  font-family: 'PingFangSC-Regular';
  text-align: center;
  font-size: 1.4rem;
  color: #ff6363;
  margin-left: 0.5rem;
}
.condition-tab {
  width: 11rem;
  height: 4rem;
  line-height: 4rem;
  font-family: 'PingFangSC-Regular';
  text-align: center;
  font-size: 1.4rem;
  color: #333333;
  margin-left: 0.5rem;
}
.bottom-border {
  border-bottom: 0.05rem solid #eeeeee;
}
</style>
